import { create } from 'zustand'

export interface EngineErrorContactInfoStore {
  result: boolean | undefined
  setEngineErrorContactInfoResponse: (result: boolean | undefined) => void
}

export const useEngineErrorContactInfoStore = create<EngineErrorContactInfoStore>(set => ({
  result: undefined,
  setEngineErrorContactInfoResponse: (param: boolean | undefined) => set({ result: param }),
}))
